/**
 * Player progression utilities for calculating level from points
 */

export const calculateLevelFromPoints = (points: number): number => {
  // Level formula: Level = floor(points / 100) + 1
  // This means: Level 1 = 0-99 points, Level 2 = 100-199 points, etc.
  return Math.floor(points / 100) + 1;
};

export const getPointsForLevel = (level: number): number => {
  // Points needed to reach a specific level
  return (level - 1) * 100;
};

export const getProgressInCurrentLevel = (points: number): { current: number; needed: number; percentage: number } => {
  const currentLevel = calculateLevelFromPoints(points);
  const pointsForCurrentLevel = getPointsForLevel(currentLevel);
  const pointsForNextLevel = getPointsForLevel(currentLevel + 1);
  
  const current = points - pointsForCurrentLevel;
  const needed = pointsForNextLevel - pointsForCurrentLevel; // Always 100
  const percentage = (current / needed) * 100;
  
  return { current, needed, percentage };
};

export const getLevelDisplayText = (points: number): string => {
  const level = calculateLevelFromPoints(points);
  return `Taso ${level}`;
};

export const getMoneyDisplayText = (amount: number): string => {
  return `${amount} €`;
};